import {Box, styled} from '@mui/material';

export const Container = styled(Box)`
	padding: 16px;
	height: 100%;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

export const StyledBox = styled(Box)`
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: 60px;
	}
`;
